import { useQuery } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';

import { FETCH_GOAL_NAME } from './goalBreadcrumb.query';

export function GoalBreadcrumb() {
  const { t } = useTranslation();
  const { data } = useQuery(FETCH_GOAL_NAME, {
    variables: { id: useParams().goalId },
  });

  function goalName(goal: any) {
    return goal.name ? goal.name : t(`client:goalType.${goal.type}`);
  }

  return data ? goalName(data.fetchGoal?.goal) : t('client:goal');
}
